import Carousel from "@/src/components/common/carousel";

import TestCard from "@/src/components/common/testCard";

const HealthPackages = ({ healthPackages }) => {
    return (
        <div className="bg-gray-100 md:py-8 py-5">
            <div className="max-w-6xl mx-auto">
                <h2 className="md:text-2xl text-xl text-black font-bold md:mb-6 mb-2 md:text-left text-center">
                    Health Packages
                </h2>

                <Carousel
                    settings={{
                        infinite: true,
                        speed: 700,
                        slidesToShow: 3,
                        slidesToScroll: 2,
                        // centerMode: true,
                        responsive: [
                            {
                                breakpoint: 600,
                                settings: {
                                    slidesToShow: 1,
                                    centerMode: true,
                                    centerPadding: "20px",
                                },
                            },
                        ],
                    }}
                >
                    {healthPackages?.length > 0 &&
                        healthPackages.map((item, index) => (
                            <TestCard
                                key={index}
                                item={item}
                                isSpacing={true}
                            />
                        ))}
                </Carousel>
            </div>
        </div>
    );
};

export default HealthPackages;
